import * as $runtime from "../runtime.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect$dConsole from "../Effect.Console/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dCart$dState$dState from "../Restaumatic.Cart.State.State/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageNoFallback from "../Restaumatic.Services.Storage.LocalStorageNoFallback/index.js";
import * as Restaumatic$dServices$dStorage$dLocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const storeCartAsPreviousOrder = storage => state => uuid => () => {
  const now = Effect$dNow.now();
  return storage._2({
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "savedAt"
    })({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "id"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "contents"})({
      encodeWithOptions: v => Restaumatic$dCart$dState$dState.encodeState.encode
    }).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  })("previousOrder")({contents: state, id: uuid, savedAt: Data$dMaybe.$Maybe("Just", now)})();
};
const loadCartFromPreviousOrder$p = storage => uuid => {
  const $0 = storage._1({
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "savedAt"
    })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readNumber(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "id"})({
      decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
    })())({reflectSymbol: () => "contents"})({decodeWithOptions: v => Restaumatic$dCart$dState$dState.decodeState.decode})()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  })("previousOrder");
  return () => {
    const v = $0();
    if (v.tag === "Just") {
      if (v._1.id === uuid) { return Data$dMaybe.$Maybe("Just", v._1.contents); }
      return Data$dMaybe.Nothing;
    }
    return Data$dMaybe.Nothing;
  };
};
const hasRecentlyOrdered = /* #__PURE__ */ (() => {
  const $0 = Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback._1({
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "savedAt"
    })({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readNumber(Data$dIdentity.monadIdentity))})())({reflectSymbol: () => "id"})({
      decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)
    })())({reflectSymbol: () => "contents"})({decodeWithOptions: v => Restaumatic$dCart$dState$dState.decodeState.decode})()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  })("previousOrder");
  return () => {
    const v = $0();
    if (v.tag === "Just") {
      if (v._1.savedAt.tag === "Just") {
        const now = Effect$dNow.now();
        return now <= v._1.savedAt._1 + 10800000.0;
      }
      return false;
    }
    return false;
  };
})();
const loadCartState = storage => () => {
  const now = Effect$dNow.now();
  const v = storage._1({
    decode: Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "state"
    })({decodeWithOptions: v => Restaumatic$dCart$dState$dState.decodeState.decode})())({reflectSymbol: () => "savedAt"})({
      decodeWithOptions: v => Foreign.readNumber(Data$dIdentity.monadIdentity)
    })()).decodeWithOptions(Foreign$dGeneric$dClass.defaultOptions)
  })("cart")();
  if (v.tag === "Nothing") { return Data$dMaybe.Nothing; }
  if (v.tag === "Just") {
    const age = Data$dInt.unsafeClamp(Data$dNumber.floor((now - v._1.savedAt) / 1000.0));
    if (now <= v._1.savedAt + 1800000.0) {
      Effect$dConsole.log("Cart loaded, age=" + Data$dShow.showIntImpl(age) + " seconds")();
      return Data$dMaybe.$Maybe("Just", v._1.state);
    }
    Effect$dConsole.log("Discarding stale cart, age=" + Data$dShow.showIntImpl(age) + " seconds")();
    return Data$dMaybe.Nothing;
  }
  $runtime.fail();
};
const moveCartToPreviousOrder = uuid => {
  const $0 = loadCartState(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback);
  return () => {
    const m_state = $0();
    if (m_state.tag === "Just") {
      storeCartAsPreviousOrder(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)(m_state._1)(uuid)();
      return Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback._2({
        encode: Foreign$dGeneric$dClass.encodeRecordNil.encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
      })("cart")({})();
    }
  };
};
const storeCartState = storage => state => () => {
  const now = Effect$dNow.now();
  return storage._2({
    encode: Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "state"})({
      encodeWithOptions: v => Restaumatic$dCart$dState$dState.encodeState.encode
    }))({reflectSymbol: () => "savedAt"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions)
  })("cart")({state, savedAt: now})();
};
const loadCartFromPreviousOrder = uuid => {
  const $0 = loadCartFromPreviousOrder$p(Restaumatic$dServices$dStorage$dLocalStorageNoFallback.localStorageNoFallback)(uuid);
  return () => {
    const m_state = $0();
    if (m_state.tag === "Just") { return storeCartState(Restaumatic$dServices$dStorage$dLocalStorageWithFallback.localStorageWithFallback)(m_state._1)(); }
  };
};
export {hasRecentlyOrdered, loadCartFromPreviousOrder, loadCartFromPreviousOrder$p, loadCartState, moveCartToPreviousOrder, storeCartAsPreviousOrder, storeCartState};
